<template>
  <div class="content">
    <div class="logo">
      <img src="../../../static/img/login/logo@2x.png" alt="">
    </div>
    <div class="login_content">
      <!-- 扫码区域 -->
      <div class="wechat_login">
        <div class="line"></div>
        <div class="code_title">扫码一键登录</div>
        <div class="code_content">
          <div class="code" @click="scanCodeRegistration">
            <img :src="codeImg" alt="" />
            <img :src="loadimg" alt="" class="loadingImg" v-show="isShowLoading">
          </div>
        </div>
        <div class="code_tip">使用<span>微信</span>扫码即可完成登录</div>
      </div>
      <!-- 密码登录 -->
      <div class="psw_login">
        <div class="psw_title">
          <span>欢迎登录</span>
          <span>百运网 - </span>
          <span>供应商中心</span>
        </div>
        <el-form :model="form" :rules="loginRules" @submit.native.prevent ref="form">
          <el-form-item prop="userNo">
            <div class="logName_input" @mouseenter="userNoMove" @mouseleave="userNoOut">
              <el-input v-model="form.userNo" placeholder="请输入账号" @focus="userNoFocus" @input="userNoInput" @blur="userNoBlur" :class="isUserError ? 'user_input_error' : ''">
                <template slot="prefix">
                  <div class="userNo_icon"></div>
                </template>
                <template slot="suffix">
                  <transition name="shanchu">
                    <div class="user_delete delete_icon" v-show="showUserNoIcon" @click="userNoDelete"></div>
                  </transition>
                </template>
              </el-input>
            </div>
          </el-form-item>
          <el-form-item prop="password">
            <div class="psw_input" @mouseenter="pswMove" @mouseleave="pswOut">
              <el-input v-model="form.password" placeholder="请输入密码" :type="isShowPsw ? 'text' : 'password'" @focus="pswFocus" @input="pswInput" @blur="pswBlur" :class="isPswError ? 'psw_input_error' : ''">
                <template slot="prefix">
                  <div class="psw_icon"></div>
                </template>
                <template slot="suffix">
                  <transition name="shanchu">
                    <div class="delete_icon" v-show="showIcon" @click="pswDelete"></div>
                  </transition>
                  <div :class="isShowPsw ? 'user_eye_show' : 'user_eye_hide'" @click="isShowPsw = !isShowPsw"></div>
                </template>
              </el-input>
            </div>
          </el-form-item>
          <div class="forget_psw"><span @click="forgetPassword">忘记密码</span></div>
          <button class="login" @click="login">登录</button>
        </el-form>
        <div class="agreement">
          <span>登录即视为同意</span>
          <span @click="agreementDialog = true">《百运物流平台合作协议》</span>
          <span @click="privacyDialog = true">《隐私政策》</span>
        </div>
      </div>
    </div>
    <!-- 商户合作协议 -->
    <el-dialog :visible.sync="agreementDialog" title="百运网-商户合作协议" width="672px" class="cooperation_agreement_dialog">
      <cooperationAgreement @agreeAgreement="closeAgreementDialog"></cooperationAgreement>
    </el-dialog>
    <!-- 隐私政策 -->
    <el-dialog :visible.sync="privacyDialog" title="百运网-隐私政策" width="672px" class="cooperation_agreement_dialog">
      <privacyPolicy @agree="closePrivacyDialog"></privacyPolicy>
    </el-dialog>
    <!-- 绑定微信 -->
    <el-dialog :visible.sync="bindWeChatDialog" title="绑定微信" width="344px" class="wechat_dialog" @close="closeBindWeChatDialog">
      <bindWeChat ref="bindingWeChat"></bindWeChat>
    </el-dialog>
    <!-- 忘记密码 -->
    <el-dialog :visible.sync="forgetPswDialog" title="忘记密码" width="328px" class="forget_dialog" :close-on-click-modal="false" @close="closeForgetDialog">
      <forgetPassword :key="time" @closeForgetDialog="closeForgetDialog"></forgetPassword>
    </el-dialog>
  </div>
</template>
<script>
import { post, fetch } from "@/ask/axios";
import cooperationAgreement from './components/cooperationAgreement.vue'
import privacyPolicy from './components/privacyPolicy.vue'
import bindWeChat from './components/bindWeChat.vue'
import { getCookie, setCookie, delCookie } from '@/ask/cookiejs'
import refreshImg from '../../../static/img/login/refresh@2x.png'
import forgetPassword from './components/forgetPassword.vue';
export default {
  head() {
    return {
      title: "登录 - 百运网供应商中心",
      meta: [
        {
          // set meta
          name: "keywords",
          content: "登录 - 百运网供应商中心",
        },
        {
          // set meta
          name: "description",
          content:
            "登录 - 百运网供应商中心",
        },
      ],
      link: [
        {
          // set link
          rel: "asstes",
          href: "https://sps.by56.com/#/login",
        },
      ],
    }
  },
  components: {
    cooperationAgreement, privacyPolicy, bindWeChat, forgetPassword
  },
  data() {
    var pswSubmit = (rule, value, callback) => {
      if (!this.form.password) {
        this.isPswError = true
        callback(new Error('请输入'))
      } else {
        this.isPswError = false
        callback()
      }
    };
    var userNoSubmit = (rule, value, callback) => {
      if (!this.form.userNo) {
        this.isUserError = true
        callback(new Error('请输入'))
      } else {
        this.isUserError = false
        callback()
      }
    };
    return {
      codeImg: "", //二维码
      form: {
        userNo: "", //账号：ZJWL
        password: "", //密码：abc123
      },
      isShowPsw: false,
      showIcon: false, //是否显示删除图标
      showUserNoIcon: false, //是否显示账号删除图标
      isUserNoFocus: false, //是否聚焦账号输入框
      isPswFocus: false, //是否聚焦密码输入框
      isUserError: false, //账号是否错误
      isPswError: false, //密码是否错误
      agreementDialog: false, //商户合作协议弹框
      bindWeChatDialog: false,//绑定微信弹框
      privacyDialog: false,//隐私政策弹框
      supdialogdown: true,
      forgetPswDialog: false,//忘记密码弹框
      timer: null,//定时器
      loginRules: {
        userNo: [
          {
            required: true,
            trigger: "submit",
            validator: userNoSubmit,
          },
        ],
        password: [
          {
            required: true,
            trigger: "submit",
            validator: pswSubmit,
          },
        ],
      },
      isCanClk: true,//限制登录点击频率
      loadimg: refreshImg, //重新获取二维码图片
      isShowLoading: false,//是否显示加载中图片
      time: "",
    };
  },
  mounted() {
    this.scanCodeRegistration();
  },
  methods: {
    // 登录
    login() {
      // if (!this.isCanClk) return;
      // this.isCanClk = false;
      // // 在3秒钟后重新启用按钮
      // setTimeout(() => {
      //   this.isCanClk = true;
      // }, 3000);
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$store.dispatch('user/login', this.form).then(() => {
            this.$router.push({ path: '/' })
          }).catch((res) => {
            this.$message({
              message: res,
              type: "error",
            });
            console.log(res);
            if (res == '该用户不存在！') {
              this.isUserError = true
            } else {
              this.isUserError = true
              this.isPswError = true
            }
          })
        } else {
          return false
        }
      });
    },
    // 扫码注册 绑定微信弹框关闭就重新调用这个接口
    scanCodeRegistration() {
      // this.bindVisible = false
      let that = this;
      that.isShowLoading = false
      // that.supdialogdown = true;
      let codeUrl = that.$apiIse + "/api/EbaySupplier/Customer/SupplierMPQRcodeSupplier";
      post(codeUrl).then((res) => {
        if (res.IsOK) {
          that.codeImg = res.Results.Code;
          let sceneValue = res.Results.SceneValue;
          setTimeout(() => {
            console.log("关闭供应商定时器");
            clearInterval(that.timer);
            // that.codeImg = that.loadimg;
            that.isShowLoading = true
          }, 60000);
          that.timer = window.setInterval(() => {
            setTimeout(() => {
              let url = that.$api04 + "/SSO/api/PollingCustomer/SupplierLogin?SceneValue="
              post(url + sceneValue
              ).then((res) => {
                // console.log("供应商扫码", res);
                let openid = res.Results.OpenId;
                // if (!that.supdialogdown) {
                //   // that.$refs["supplierDialog"].bindVisible = false;
                //   clearInterval(suppliertimer);
                //   openid = null;
                // }
                if (openid !== null) {
                  clearInterval(that.timer);
                  that.bindWeChatDialog = true
                  setTimeout(() => {
                    this.$nextTick(() => {
                      this.$refs["bindingWeChat"].weChatID =
                        res.Results.UnionId;
                      this.$refs["bindingWeChat"].openId =
                        res.Results.OpenId;
                    })
                  }, 1000)
                }
                if (res.IsOK) {
                  setCookie("X-JWT-SUPTOKEN", res.Results.data.Token);
                  setCookie("IM-TOKENSUP", res.Results.data.IMToken);
                  setCookie("SuplierLoginName", res.Results.data.CustomerName);
                  clearInterval(that.timer);
                  setTimeout(() => {
                    // this.$router.push({ path: '/' })
                    window.location.href = '/'
                  }, 2000)
                }
              });
            }, 0);
          }, 2000);
        }
      });
    },
    // 忘记密码
    forgetPassword() {
      this.forgetPswDialog = true
      this.time = Number(new Date())
    },
    // 关闭微信绑定弹框
    closeBindWeChatDialog() {
      this.scanCodeRegistration()
    },
    closeForgetDialog() {
      this.forgetPswDialog = false
    },
    // 关闭商户合作协议弹框
    closeAgreementDialog() {
      this.agreementDialog = false
    },
    // 关闭隐私政策弹框
    closePrivacyDialog() {
      this.privacyDialog = false
    },

    // 聚焦密码输入框
    pswFocus() {
      this.isPswFocus = true;
      this.isPswError = false
      if (this.form.password) {
        this.showIcon = true;
      } else {
        this.showIcon = false;
      }
    },
    // 失焦密码输入框
    pswBlur() {
      setTimeout(() => {
        this.isPswFocus = false;
        this.showIcon = false;
      }, 100);
    },
    // 移入密码输入框
    pswMove() {
      if (this.form.password && !this.isPswFocus) {
        this.showIcon = true;
      }
    },
    // 移出密码输入框
    pswOut() {
      if (!this.isPswFocus) {
        this.showIcon = false;
      }
    },
    // 监听密码输入框
    pswInput() {
      this.showIcon = this.form.password.length > 0;
    },
    // 清楚密码
    pswDelete() {
      this.form.password = "";
      this.isPswError = false
      this.isPswFocus = false
      this.showIcon = false;
    },
    // 聚焦账号输入框
    userNoFocus() {
      this.isUserNoFocus = true;
      this.isUserError = false;
      if (this.form.userNo) {
        this.showUserNoIcon = true;
      } else {
        this.showUserNoIcon = false;
      }
    },
    // 失焦账号输入框
    userNoBlur() {
      setTimeout(() => {
        this.isUserNoFocus = false;
        this.showUserNoIcon = false;
      }, 100);
    },
    // 移入账号输入框
    userNoMove() {
      if (this.form.userNo && !this.isUserNoFocus) {
        this.showUserNoIcon = true;
      }
    },
    // 移出账号输入框
    userNoOut() {
      if (!this.isUserNoFocus) {
        this.showUserNoIcon = false;
      }
    },
    // 监听账号输入框
    userNoInput() {
      this.showUserNoIcon = this.form.userNo.length > 0;
    },
    // 清楚账号
    userNoDelete() {
      this.form.userNo = "";
      this.isUserError = false
      this.isUserNoFocus = false
      this.showUserNoIcon = false;
    },
  },
  beforeDestroy() {
    clearInterval(this.timer); // 清除定时器
  }
};
</script>
<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100%;
  background: url("../../../static/img/login/background@2x.png");
  background-size: cover;
  position: relative;
  background-position: center;
}
.logo {
  position: absolute;
  top: 40px;
  left: 40px;
  img {
    width: 211px;
    height: 39px;
  }
}
.login_content {
  width: 624px;
  height: 380px;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0px 8px 16px 0px rgba(85, 111, 183, 0.03);
  border-radius: 16px;
  border: 2px solid #ffffff;
  backdrop-filter: blur(4px);
  position: absolute;
  left: 50vw;
  margin-left: -312px;
  top: 50vh;
  margin-top: -190px;
  display: flex;
}
.wechat_login {
  width: 264px;
  flex-shrink: 0;
  position: relative;
  .code_title {
    height: 32px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 32px;
    text-align: center;
    margin-top: 66px;
  }
  .code_content {
    width: 152px;
    height: 152px;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #ccdaf1;
    margin: 16px auto;
    .code {
      width: 144px;
      height: 144px;
      margin: 4px;
      cursor: pointer;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
      .loadingImg {
        position: absolute;
        top: 0px;
        left: 0px;
      }
    }
  }
  .code_tip {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #777777;
    line-height: 24px;
    text-align: center;
    span {
      color: #4dae1f;
    }
  }
}
.psw_login {
  padding: 0 40px;
  box-sizing: border-box;
  width: 360px;
  flex-shrink: 0;
  height: 100%;
  position: relative;
  .psw_title {
    height: 40px;
    margin-top: 36px;
    span {
      font-family: AlibabaPuHuiTiM;
      color: #333333;
    }
    span:nth-of-type(1) {
      font-size: 24px;
      line-height: 40px;
    }
    span:nth-of-type(2) {
      font-size: 14px;
      line-height: 24px;
      margin-left: 16px;
    }
    span:nth-of-type(3) {
      font-size: 14px;
      color: #333333;
      line-height: 24px;
      background: linear-gradient(180deg, #0046b9 0%, #5630d0 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
}

.psw_login ::v-deep .el-form {
  .el-form-item {
    margin: 0;
  }
  .el-form-item__content {
    line-height: 48px;
  }
}
.psw_login ::v-deep .el-input {
  .el-input__inner {
    height: 48px !important;
    background: #ffffff;
    box-shadow: 0px 0px 0px 2px rgba(0, 70, 185, 0);
    border-radius: 8px;
    border: 1px solid #dddddd !important;
    line-height: 48px !important;
    transition: border 0.2s;
    padding: 0 56px 0 40px !important;

    &:hover {
      border: 1px solid #aaaaaa !important;
      transition: border 0.2s;
    }
    &:focus {
      border: 1px solid #0046b9 !important;
      transition: border 0.2s;
    }
  }
  .el-input__suffix {
    right: 0;
  }
  .el-input__suffix-inner {
    display: flex;
    margin: 16px 0;
  }
}
.psw_login ::v-deep .el-input .el-input__inner::placeholder {
  font-size: 14px;
  font-family: AlibabaPuHuiTiR;
  color: #999999;
}
.logName_input
  ::v-deep
  .el-input
  .el-input__inner:focus
  + .el-input__prefix
  .userNo_icon {
  background: url("../../../static/img/login/ic_login_account_active@2x.png")
    no-repeat;
  background-size: 16px 16px;
  background-position: center;
  transition: background 0.2s;
}
.psw_input
  ::v-deep
  .el-input
  .el-input__inner:focus
  + .el-input__prefix
  .psw_icon {
  background: url("../../../static/img/login/ic_login_password_active@2x.png")
    no-repeat;
  background-size: 16px 16px;
  background-position: center;
  transition: background 0.2s;
}
// .psw_login ::v-deep .el-input .el-input__inner:focus
.logName_input {
  margin-top: 32px;
}
.psw_input {
  margin-top: 16px;
}
.userNo_icon {
  width: 36px;
  height: 48px;
  background: url("../../../static/img/login/ic_login_account_normal@2x.png")
    no-repeat;
  background-size: 16px 16px;
  background-position: center;
  transition: background 0.2s;
}
.psw_icon {
  width: 36px;
  height: 48px;
  background: url("../../../static/img/login/ic_login_password_normal@2x.png")
    no-repeat;
  background-size: 16px 16px;
  background-position: center;
  transition: background 0.2s;
}
.delete_icon {
  width: 16px;
  height: 16px;
  background: url("../../../static/img/login/ic_login_delete_normal@2x.png")
    no-repeat;
  background-size: 16px 16px;
  cursor: pointer;
  &:hover {
    background: url("../../../static/img/login/ic_login_delete_hover@2x.png")
      no-repeat;
    background-size: 16px 16px;
  }
  &:active {
    background: url("../../../static/img/login/ic_login_delete_click@2x.png")
      no-repeat;
    background-size: 16px 16px;
  }
}
.user_delete {
  margin-right: 16px;
}
.user_eye_hide {
  width: 16px;
  height: 16px;
  background: url("../../../static/img/login/ic_login_show_normal@2x.png")
    no-repeat;
  background-size: 16px 16px;
  margin: 0 16px 0 8px;
  cursor: pointer;
  &:hover {
    background: url("../../../static/img/login/ic_login_show_hover@2x.png")
      no-repeat;
    background-size: 16px 16px;
  }
  &:active {
    background: url("../../../static/img/login/ic_login_show_click@2x.png")
      no-repeat;
    background-size: 16px 16px;
  }
}
.user_eye_show {
  width: 16px;
  height: 16px;
  background: url("../../../static/img/login/ic_login_hide_normal@2x.png")
    no-repeat;
  background-size: 16px 16px;
  margin: 0 16px 0 8px;
  cursor: pointer;
  &:hover {
    background: url("../../../static/img/login/ic_login_hide_hover@2x.png")
      no-repeat;
    background-size: 16px 16px;
  }
  &:active {
    background: url("../../../static/img/login/ic_login_hide_click@2x.png")
      no-repeat;
    background-size: 16px 16px;
  }
}
.psw_login .user_input_error ::v-deep .el-input__inner {
  box-shadow: 0px 0px 0px 2px rgba(216, 63, 63, 0.08) !important;
  border-radius: 8px;
  border: 1px solid #d83f3f !important;
  &::placeholder {
    color: #d83f3f;
  }
  &:hover {
    border: 1px solid #d83f3f !important;
    transition: border 0.2s;
  }
}
.psw_login .user_input_error ::v-deep .el-input__prefix .userNo_icon {
  width: 36px;
  height: 48px;
  background: url("../../../static/img/login/ic_login_account_error@2x.png")
    no-repeat;
  background-size: 16px 16px;
  background-position: center;
  transition: background 0.2s;
}
.psw_login .psw_input_error ::v-deep .el-input__inner {
  box-shadow: 0px 0px 0px 2px rgba(216, 63, 63, 0.08) !important;
  border-radius: 8px;
  border: 1px solid #d83f3f !important;
  &:hover {
    border: 1px solid #d83f3f !important;
    transition: border 0.2s;
  }
  &::placeholder {
    color: #d83f3f;
  }
}
.psw_login .psw_input_error ::v-deep .el-input__prefix .psw_icon {
  width: 36px;
  height: 48px;
  background: url("../../../static/img/login/ic_login_password_error@2x.png")
    no-repeat;
  background-size: 16px 16px;
  background-position: center;
  transition: background 0.2s;
}
.forget_psw {
  height: 24px;
  line-height: 24px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #777777;
  margin: 8px 0 16px;
  text-align: right;
  transition: color 0.2s;
  cursor: pointer;
  span {
    &:hover {
      color: #0046b9;
      transition: color 0.2s;
    }
  }
}
.login {
  width: 280px;
  height: 48px;
  background: linear-gradient(270deg, #0059eb 0%, #2e7cff 100%);
  border-radius: 8px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  outline: none;
  border: none;
  transition: background 0.2s;
  cursor: pointer;
  &:hover {
    background: linear-gradient(270deg, #2973ee 0%, #4f91ff 100%);
    transition: background 0.2s;
  }
  &:active {
    background: linear-gradient(270deg, #0059eb 0%, #2e7cff 100%);
    transition: background 0.2s;
  }
}
.agreement {
  height: 24px;
  width: 312px;
  text-align: center;
  line-height: 24px;
  position: absolute;
  bottom: 32px;
  right: 24px;

  span {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #0046b9;
    cursor: pointer;
  }
  span:nth-of-type(1) {
    color: #aaaaaa;
    cursor: default;
  }
}
::v-deep .el-dialog {
  border-radius: 4px;
  .el-dialog__header {
    padding: 16px 24px;
    border-bottom: solid 1px #f0f0f0;
    .el-dialog__title {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }
  }
  .el-dialog__body {
    padding: 16px 24px 24px;
    height: 464px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #777777;
    &:hover {
      color: #0046b9;
    }
  }
}
.cooperation_agreement_dialog ::v-deep .el-dialog {
  top: 50% !important;
  margin-top: -260px !important;
}
.wechat_dialog::v-deep .el-dialog {
  top: 50% !important;
  margin-top: -168px !important;
  border-radius: 8px;
  .el-dialog__body {
    padding: 16px 24px 16px;
    height: 280px;
  }
}
.forget_dialog::v-deep .el-dialog {
  top: 50% !important;
  margin-top: -128px !important;
  border-radius: 16px;
  backdrop-filter: blur(6px);
  .el-dialog__header {
    padding: 20px 16px 20px 24px;
    border-bottom: none;
  }
  .el-dialog__body {
    padding: 8px 24px 16px;
    height: 192px;
  }
}
::v-deep .el-form-item.is-error {
  // margin-bottom: 24px;
  & .el-form-item__error {
    display: none;
  }
}
.line {
  width: 2px;
  height: 312px;
  background: #ffffff;
  position: absolute;
  right: 0;
  top: 32px;
}

@font-face {
  font-family: "AlibabaPuHuiTiM";
  src: url("../../assets/fontFamily/Alibaba-PuHuiTi-Medium.otf")
    format("opentype");
  /* Other font-face properties (font-weight, font-style, etc.) */
}
@font-face {
  font-family: "AlibabaPuHuiTiR";
  src: url("../../assets/fontFamily/Alibaba-PuHuiTi-Regular.otf")
    format("opentype");
  /* Other font-face properties (font-weight, font-style, etc.) */
}
.shanchu-enter,
.shanchu-leave-to {
  opacity: 0;
}
.shanchu-enter-to,
.shanchu-leave {
  opacity: 1;
}
.shanchu-enter-active,
.shanchu-leave-active {
  transition: all 0.2s;
}
</style>
